import { render, staticRenderFns } from "./regb.vue?vue&type=template&id=f707015a&scoped=true"
import script from "./regb.vue?vue&type=script&lang=js"
export * from "./regb.vue?vue&type=script&lang=js"
import style0 from "./regb.vue?vue&type=style&index=0&id=f707015a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707015a",
  null
  
)

export default component.exports